import { render } from "./Setting2StatusStep.vue?vue&type=template&id=2c499df7"
import script from "./Setting2StatusStep.vue?vue&type=script&lang=js"
export * from "./Setting2StatusStep.vue?vue&type=script&lang=js"

import "./Setting2StatusStep.vue?vue&type=style&index=0&id=2c499df7&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__